export const isNpmPackage = true;
